
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class Name extends Vue {
  private data: any = [
    {
      name: "项目负责人",
      des: "负责整个项目下各级机构的测评管理及其帐户管理 。",
    },
    {
      name: "医院管理员",
      des: "支持查看该机构及其下属账户创建的的全部会员，同时也可以新增会员，支持修改客户基本信息，测评数据采集、出具评估报告；支持修改团体管理和机构设置 。",
    },
    {
      name: "高级医生",
      des: "支持查看该机构下的科室及其下属账户创建的的全部会员，同时也可以新增会员，支持修改客户基本信息，测评数据采集、出具评估报告。",
    },
    {
      name: "普通医生",
      des: "只能查看该账户自己创建的会员，支持修改客户基本信息，测评数据采集、出具评估报告。",
    },
  ];
}
